import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { KeyValueModel } from 'app/shared/models/KeyValueModel';
import { NotificationService } from 'app/shared/services/notification.service';
import { InputBaseReactComponent } from '../input-base-react/input-base-react.component';

@Component({
  selector: 'app-input-keyvalue-list',
  templateUrl: './input-keyvalue-list.component.html',
  styleUrls: ['./input-keyvalue-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputKeyvalueListComponent),
      multi: true
    }]
})
export class InputKeyvalueListComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit {

  @Input() nomeChave: string = null;
  @Input() nomeValor: string = null;
  @Input() listaCampos: Array<string> = [];
  @Input() listaLabels: Array<string> = [];
  @Input() listaChaves: Array<any> = [];
  @Input() nomeForm: any = null;
  @Input() valueTipoDate = false;
  @Input() usarCustomKeyValue = false;
  @Input() permitirEdicao = true;

  constructor(
    private notification: NotificationService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.validarForm();
  }

  desativarBotao() {
    if (this.form !== undefined) {
      const chave = this.form.get(this.nomeChave) as FormControl;
      const valor = this.form.get(this.nomeValor) as FormControl;

      if ((chave && chave.value !== '') && (valor && valor.value !== '')) {
        return true;
      }
    }
    return false;
  }

  removerItem(index: number) {
    const lista = this.obterLista();

    if (index >= 0) {
      lista.splice(index, 1);
    }

    this.control.setValue(lista);
    this.validarForm();
  }

  adicionarItem() {
    const chave = this.form.get(this.nomeChave).value;
    const valor = this.form.get(this.nomeValor).value;

    if (chave !== undefined && chave !== null && valor !== undefined && valor !== null) {
      let lista = this.obterLista();

      if (!lista) {
        if (this.usarCustomKeyValue) {
          lista = new Array<any>();
        } else {
          lista = new Array<KeyValueModel>();
        }
      }

      if ((!this.usarCustomKeyValue && !lista.find(i => i.key === chave)) || (this.usarCustomKeyValue && !lista.find(i => i[this.nomeChave] === chave))) {
        if (this.usarCustomKeyValue) {
          const value = {}
          value[this.nomeChave] = chave
          value[this.nomeValor] = valor
          lista.push(value);
        } else {
          lista.push(new KeyValueModel(chave, valor));
          }
        this.form.get(this.name).setValue(lista);
        this.form.get(this.nomeChave).setValue('');
        this.form.get(this.nomeValor).setValue('');
        this.validarForm();
      } else {
        this.notification.alerta('Item já vinculado.');
      }
    } else {
      this.notification.alerta('Item invalido.')
    }
  }

  modificarItem(): void {
    const chave = this.form.get(this.nomeChave).value;
    const valor = this.form.get(this.nomeValor).value;

    if (chave !== undefined && chave !== null && valor !== undefined && valor !== null) {
      let lista = this.obterLista();

      if (!lista) {
        lista = new Array<KeyValueModel>();
      }

      const index = this.usarCustomKeyValue? lista.findIndex(m => m[this.nomeChave] === chave): lista.findIndex(m => m.key === chave);

      if (index >= 0) {
        if (this.usarCustomKeyValue) {
          const value = {}
          value[this.nomeChave] = chave
          value[this.nomeValor] = valor
          lista[index] = value;
        } else {
          lista[index] = new KeyValueModel(chave, valor);
        }
        this.control.setValue(lista);
      } else {
        this.adicionarItem();
      }
    } else {
      this.notification.alerta('Parâmetro inválido.');
    }
  }

  carregarItem(index: number) {
    const itemSelecionado = this.obterLista()[index];

    this.form.get(this.nomeChave).setValue(this.usarCustomKeyValue? itemSelecionado[this.nomeChave]:itemSelecionado.key);
    this.form.get(this.nomeValor).setValue(this.usarCustomKeyValue? itemSelecionado[this.nomeValor]:itemSelecionado.value);
  }

  obterLista(): Array<KeyValueModel | any> {
    this.validarForm();
    if (this.usarCustomKeyValue) {
      return this.control.value as Array<any>;
    }
    return this.control.value as Array<KeyValueModel>;
  }

  listaVazia(): boolean {
    let lista = null;
    if (this.control !== undefined) {
      lista = this.control.value as Array<any>;
    }
    return lista == null || lista.length === 0 ? true : false;
  }

  listaCamposVazia(): boolean {
    return this.listaCampos.length === 0;
  }

  obterCampos(): Array<string> {
    if (this.listaLabels.length === this.listaCampos.length) {
      return this.listaLabels;
    }
    return this.listaCampos;
  }

  validarForm() {
    if (this.required) {
      if (this.control.value === null || this.control.value.length === 0) {
        this.form.get(this.name).setErrors({ 'incorrect': true })
      } else {
        this.form.get(this.name).setErrors(null)
      }
    }
  }

  obterNomeChave(id) {
    if (this.usarCustomKeyValue) {
      const item = this.listaChaves.find(e => e[this.nomeChave] === id);
      return item ? item[this.nomeChave] : id;
    }
    const item = this.listaChaves.find(e => e.id === id);
    return item ? item.nome : id;
  }
  obterValue(str) {
    if (this.valueTipoDate) {
      return new Date(str).toLocaleDateString();
    }
    return str;
  }
}
